import React from 'react';
import * as Style from './style.module.scss';

interface ButtonTogglerProps {
    checked?: boolean;
    onChange?: (checked: boolean) => void;
    disabled?: boolean;
    /** the switch renders no visible text, so callers should describe what it toggles */
    ariaLabel?: string;
}

const ButtonToggler: React.FC<ButtonTogglerProps> = ({
    checked,
    onChange,
    disabled,
    ariaLabel = 'Toggle'
}) => {
    return (
        <label
            aria-label={ariaLabel}
            className={`${Style.switch} ${disabled ? Style.disabled : ''}`}
        >
            <input
                type="checkbox"
                className={`${Style.input}`}
                onChange={(event) => {
                    onChange?.(event.target.checked);
                }}
                checked={checked}
                disabled={disabled}
            />
            <span className={`${Style.slider} ${Style.round}`}></span>
        </label>
    );
};

export default ButtonToggler;
